(function () {
  var SELECTOR = '[data-collection-slider]';

  function init(container) {
    var sliders = container.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(sliders, function (slider) {
      if (typeof Swiper === 'undefined' || slider.swiper) return;

      var wrapper = slider.parentNode;

      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        freeMode: true,
        navigation: {
          prevEl: wrapper.querySelector('[data-collection-slider-prev]'),
          nextEl: wrapper.querySelector('[data-collection-slider-next]')
        },
        breakpoints: {
          768: { spaceBetween: 20 },
          992: { spaceBetween: 28 }
        }
      });
    });
  }

  function destroy(container) {
    var sliders = container.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(sliders, function (slider) {
      if (slider.swiper) slider.swiper.destroy(true, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
